import { render, staticRenderFns } from "./MaterialMapperEdit.vue?vue&type=template&id=60234e02&"
import script from "./MaterialMapperEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialMapperEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports